import type { SVGProps } from "react"
import { iconPaths } from "./iconPaths.tsx"

export type IconName = keyof typeof iconPaths

interface IconProps extends Omit<SVGProps<SVGSVGElement>, "name"> {
  name: IconName
  size?: number
}

export const Icon = ({ name, size = 20, color, ...restProps }: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={size} height={size} fill="none" color={color} {...restProps}>
    {iconPaths[name]}
  </svg>
)

// Create a static property for available icon names
Icon.names = Object.keys(iconPaths) as IconName[]
